import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BottomSheetHostDirective } from './bottom-sheet-host.directive';
import { BottomSheetComponent } from './bottom-sheet.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [BottomSheetComponent, BottomSheetHostDirective],
    declarations: [BottomSheetComponent, BottomSheetHostDirective],
    providers: [],
})
export class BottomSheetModule { }
